import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Table/table';
var visibilityModifiers = ['hidden', 'hiddenOnSm', 'hiddenOnMd', 'hiddenOnLg', 'hiddenOnXl', 'hiddenOn_2xl', 'visibleOnSm', 'visibleOnMd', 'visibleOnLg', 'visibleOnXl', 'visibleOn_2xl'];
export var Visibility = visibilityModifiers.filter(function (key) {
  return styles.modifiers[key];
}).reduce(function (acc, curr) {
  var key2 = curr.replace('_2xl', '2Xl');
  acc[key2] = styles.modifiers[curr];
  return acc;
}, {});
export var classNames = function classNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return function () {
    return {
      className: css.apply(void 0, classes)
    };
  };
};